/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from "react";
import type { SVGIconProps } from "../../svgIconProps";
import { IconSize } from "../../iconTypes";
import { SVGIconContainer } from "../../svgIconContainer";

export const VolumeMedium: React.FC<SVGIconProps> = React.forwardRef<any, SVGIconProps>(({size = IconSize.STANDARD, ...props}, ref) => {
    const isLarge = size! >= IconSize.LARGE;
    const pixelGridSize = isLarge ? IconSize.LARGE : IconSize.STANDARD;
    const translation = `${-1 * pixelGridSize / 0.014705882352941176 / 2}`;
    const style = { transformOrigin: "center" };
    return (
        <SVGIconContainer iconName="volume-medium" ref={ref} size={size} {...props}>
            <path
                d={isLarge ? "M850 113.3333333333335L510 453.3333333333334H226.6666666666667V793.3333333333334A113.3333333333333 113.3333333333333 0 0 0 340 906.6666666666669H510L850 1246.6666666666667V113.3333333333335zM558.1666666666666 793.3333333333334H340V566.6666666666667H558.1666666666666L736.6666666666666 388.1666666666668V971.8333333333334L558.1666666666666 793.3333333333334zM963.3333333333331 906.6666666666669C1005.8333333333331 886.8333333333334 1040.06 856.1200000000001 1066.07 814.5833333333334C1092.023333333333 773.0466666666666 1105 727.26 1105 677.1666666666666C1105 627.13 1091.9666666666667 581.7966666666666 1066.0133333333333 541.1666666666666A240.89 240.89 0 0 0 963.3333333333331 450.5V906.6666666666669z" : "M680 90.6666666666666L408 362.6666666666667H181.3333333333334V634.6666666666666A90.6666666666667 90.6666666666667 0 0 0 272 725.3333333333333H408L680 997.3333333333334V90.6666666666666zM446.5333333333334 634.6666666666666H272V453.3333333333333H446.5333333333334L589.3333333333334 310.5333333333333V777.4666666666667L446.5333333333334 634.6666666666666zM770.6666666666667 725.3333333333333C804.6666666666667 709.4666666666667 832.048 684.896 852.856 651.6666666666666C873.6186666666666 618.4373333333333 884 581.808 884 541.7333333333332C884 501.704 873.5733333333334 465.4373333333333 852.8106666666667 432.9333333333333A192.712 192.712 0 0 0 770.6666666666667 360.4V725.3333333333333z"}
                fillRule="evenodd"
                transform={`scale(0.014705882352941176, -0.014705882352941176) translate(${translation}, ${translation})`}
                style={style}
            />
        </SVGIconContainer>
   );
});
VolumeMedium.displayName = `Blueprint5.Icon.VolumeMedium`;
export default VolumeMedium;
